<template>
    <div class="layout-header">
        <div>
            <img class="logo" src="../assets/img/layout/logo.png" alt="" />
        </div>
        <div class="layout-header-r">


            <div class="lang">
                <Popover class="lang-popover" v-model="langShow" :offset="[60, 20]">
                    <div class="lang-popup">
                        <div class="lang-title">{{ $t('header.selectLang') }}</div>
                        <div class="lang-grid">
                            <div :class="{ active: $i18n.locale === 'en' }" @click="handleLang('en')">EN</div>
                            <div :class="{ active: $i18n.locale === 'zh' }" @click="handleLang('zh')">CN</div>
                            <div :class="{ active: $i18n.locale === 'jp' }" @click="handleLang('jp')">JP</div>
                            <div :class="{ active: $i18n.locale === 'kr' }" @click="handleLang('kr')">KR</div>
                            <div :class="{ active: $i18n.locale === 'vn' }" @click="handleLang('vn')">VN</div>
                            <div :class="{ active: $i18n.locale === 'th' }" @click="handleLang('th')">TH</div>
                            <div :class="{ active: $i18n.locale === 'id' }" @click="handleLang('id')">ID</div>
                            <div :class="{ active: $i18n.locale === 'ph' }" @click="handleLang('ph')">PH</div>
                            <div :class="{ active: $i18n.locale === 'kh' }" @click="handleLang('kh')">KH</div>
                            <div :class="{ active: $i18n.locale === 'la' }" @click="handleLang('la')">LA</div>
                            <div :class="{ active: $i18n.locale === 'mm' }" @click="handleLang('mm')">MM</div>
                            <div :class="{ active: $i18n.locale === 'ru' }" @click="handleLang('ru')">RU</div>
                            <div :class="{ active: $i18n.locale === 'ae' }" @click="handleLang('ae')">AE</div>
                            <div :class="{ active: $i18n.locale === 'tr' }" @click="handleLang('tr')">TR</div>
                            <div :class="{ active: $i18n.locale === 'il' }" @click="handleLang('il')">IL</div>
                            <div :class="{ active: $i18n.locale === 'es' }" @click="handleLang('es')">ES</div>
                            <div :class="{ active: $i18n.locale === 'br' }" @click="handleLang('br')">BR</div>
                        </div>
                    </div>
                    <template #reference>
                        <img @click="langShow = true" src="../assets/img/layout/langs.png" alt="" />
                    </template>
                </Popover>
            </div>
            <div class="layout-header-r-c">
                <div class="point"></div>

                <span>{{this.$store.state.globalAddress.slice(0,6) +"***" +this.$store.state.globalAddress.slice(38,42)}}</span>
            </div>
            <div class="menu" @click="menuShow = true">
                <img src="../assets/img/layout/menu.png" alt="" />
            </div>
        </div>

        <Popup v-model="menuShow" class="menuPopup" get-container="#app" position="left">
            <div class="menu-header">
                <div class="logo">
                    <img src="../assets/img/layout/logo.png" alt="">
                </div>
                <img @click="menuShow = false" src="../assets/img/layout/menus/close.png" alt="">
            </div>

            <div class="user-info">
                <div class="tier-badge">
                    <div>
                        D{{VIP}}
                    </div>
                </div>
                <div class="user-tier">
                    <div>
                        {{this.$store.state.globalAddress.slice(0,6) +"***" +this.$store.state.globalAddress.slice(38,42)}}
                        <!-- <span>D7</span> -->
                    </div>
                    <span class="tier-label">BD-ID · {{memberNO}}</span>
                </div>
            </div>


            <template v-for="(section, index) in menu" >
                <div class="menu-section" >
                    <div class="section-title">{{ $t(section.title) }}</div>
                    <div 
                        v-for="(item, itemIndex) in section.children" 
                        :key="itemIndex"
                        class="menu-item"
                        :class="{ active: $route.name === item.path }"
                        @click="handleMenu(item)"
                    >
                        <div class="icon" :class="{ active: $route.name === item.path }">
                            <img 
                                v-if="$route.name === item.path" 
                                :src="require('../assets/img/layout/menus/' + item.icon + '-active.png')" 
                                alt=""
                            >
                            <img 
                                v-else 
                                :src="require('../assets/img/layout/menus/' + item.icon + '.png')" 
                                alt=""
                            >
                        </div>
                        <span>{{ $t(item.title) }}</span>
                        <!-- <span v-if="item.badge" class="badge">{{ item.badge }}</span> -->
                    </div>
                </div>
                
                <div class="menu-divider"  v-if="index < menu.length - 1"></div>
            </template>

            <div class="menu-langs">
                <div class="section-title">
                    <div>{{ $t('header.language') }}</div>

                    <span>16</span>
                </div>
                <div class="lang-grid">
                    <div :class="{ active: $i18n.locale === 'en' }" @click="handleLang('en')">EN</div>
                    <div :class="{ active: $i18n.locale === 'zh' }" @click="handleLang('zh')">CN</div>
                    <div :class="{ active: $i18n.locale === 'jp' }" @click="handleLang('jp')">JP</div>
                    <div :class="{ active: $i18n.locale === 'kr' }" @click="handleLang('kr')">KR</div>
                    <div :class="{ active: $i18n.locale === 'vn' }" @click="handleLang('vn')">VN</div>
                    <div :class="{ active: $i18n.locale === 'th' }" @click="handleLang('th')">TH</div>
                    <div :class="{ active: $i18n.locale === 'id' }" @click="handleLang('id')">ID</div>
                    <div :class="{ active: $i18n.locale === 'ph' }" @click="handleLang('ph')">PH</div>
                    <div :class="{ active: $i18n.locale === 'kh' }" @click="handleLang('kh')">KH</div>
                    <div :class="{ active: $i18n.locale === 'la' }" @click="handleLang('la')">LA</div>
                    <div :class="{ active: $i18n.locale === 'mm' }" @click="handleLang('mm')">MM</div>
                    <div :class="{ active: $i18n.locale === 'ru' }" @click="handleLang('ru')">RU</div>
                    <div :class="{ active: $i18n.locale === 'ae' }" @click="handleLang('ae')">AE</div>
                    <div :class="{ active: $i18n.locale === 'tr' }" @click="handleLang('tr')">TR</div>
                    <div :class="{ active: $i18n.locale === 'il' }" @click="handleLang('il')">IL</div>
                    <div :class="{ active: $i18n.locale === 'es' }" @click="handleLang('es')">ES</div>
                    <div :class="{ active: $i18n.locale === 'br' }" @click="handleLang('br')">BR</div>
                </div>

            </div>
        </Popup>

    </div>
</template>
<script>
import { ActionSheet, Popover, Icon, Popup, Field } from 'vant';
import { setLanguage } from "@/utils/cookies";
import { Locale } from 'vant';
import { copyToClipboard } from "@/utils";

import axios from 'axios'
import Web3 from 'web3'
import contractaa from '../views/contract/index.js';

let web3

export default {
    name: 'layout-header',
    components: {
        ActionSheet,
        Icon,
        Popup,
        Field,
        Popover
    },
    data() {
        return {
            isLogin: true,
            show: false,
            show1: false,
            check: false,
            menuShow: false,
            langShow: false,
            linkShow: false,
            walletIcon: '',
            userName: '0x...',
            actions: [

            ],
            checkItem: '',
            memberNO:'',
            VIP:0
        };
    },
    computed: {
        menuItem() {
            for (const section of this.menu) {
                const item = section.children.find(child => this.$route.name === child.path);
                if (item) return item;
            }
            return null;
        },
        menu() {
            return [
                {
                    title: 'header.trading',
                    children: [
                        { title: 'header.dashboard', icon: 'icon-dashboard', path: 'home' },
                        { title: 'header.subscribeMatrix', icon: 'icon-matrix', path: 'staking' },
                        { title: 'header.portTaskCenter', icon: 'icon-task', path: 'port', badge: '+20' }
                    ]
                },
                {
                    title: 'header.network',
                    children: [
                        { title: 'header.apiBinding', icon: 'icon-apibind', path: 'bindapi' },
                        { title: 'header.gridTree', icon: 'icon-internet', path: 'internet' }
                    ]
                },
                {
                    title: 'header.account',
                    children: [
                        { title: 'header.documents', icon: 'icon-doc', path: 'whitePaper' },
                        { title: 'header.personalCenter', icon: 'icon-user', path: 'me' }
                    ]
                }
            ]
        }
    },
    watch: {
        '$route.path'(path) {
            this.menuShow = false;

        }

    },
    methods: {
        toggleSound() {
            this.$store.commit('toggleSound')
        },
        handleLink() {
            if (this.isLogin) {
                this.linkShow = !this.linkShow
            } else {
                this.linkShow = false
            }
        },
        handleMenu(item) {
            this.menuShow = false;
            if (item.path) {
                this.$router.push({
                    name: item.path
                });
            }
            if (item.lang) {
                this.$i18n.locale = item.lang;
                setLanguage(item.lang)
                Locale.use(item.lang, this.$i18n.messages[item.lang])

            }

        },
        handleLang(lang) {
            this.$i18n.locale = lang;
            setLanguage(lang)
            Locale.use(lang, this.$i18n.messages[lang])
            this.langShow = false

        },
        copy(text) {
            copyToClipboard(text)
        },
        async userlogin(){
            var that = this;
            if(typeof window.ethereum !='undefined'  ){
                console.log('安装了插件')
                web3 = new Web3(window.ethereum);
                const chainId = await window.ethereum.request({
                    method: 'eth_chainId'
                })
                //console.log(chainId)
                if(chainId!='0x38'){
                    await window.ethereum.request({
                        method: 'wallet_switchEthereumChain',
                        params: [{ chainId: '0x38' }] // BSC
                    })
                }
                
                ethereum.request({ method: 'eth_requestAccounts' }).then(handleAccountsChanged=>{
                that.userName = Web3.utils.toChecksumAddress(handleAccountsChanged[0]);
                that.$store.state.globalAddress = that.userName;
                  //console.log("链接地址："+that.userName);
                  //签名
                    var vstr = "Welcome to BitDeep";
                    vstr = web3.utils.utf8ToHex(vstr);

                    ethereum.request({method: "personal_sign",params: [vstr, that.userName],}).then((signature) => {
                            let _vcode = that.shareLeaderCode
                            let _sigin = signature
                            //console.log("签名："+signature);
                            //console.log("vode："+_vcode);

                            //ajax 提交注册信息
                            axios.post(contractaa.APIURL+'?cmd=login',"addr="+that.userName+"&singer="+_sigin+"&vcode="+_vcode).then(function (response) {
                            if (response.status === 200) {
                                    //console.log("axios请求状态")
                                    //console.log(response.data.Status)
                                    let _arr = response.data.Message.split('|')
                                    that.$store.state.vcode = _arr[0];
                                    that.memberNO = _arr[0]
                                    that.VIP = _arr[1]
                                    if(!response.data.Status){
                                        that.$toast.fail(that.$t('withdraw.withdrawFailed'))
                                        return;
                                    }
                                    //console.log(response.data.Message)
                                    that.$toast.success(that.$t('withdraw.withdrawSuccess'));
                                    that.$store.state.islogin = true;
                                    that.$emit("ready")
                                }
                            })
                           

                        }).catch((err) => {
                            // 异常
                            console.log("签名提交出错："+err)
                        });
                }).catch((error) => {
                if (error.code === 4001) {
                    console.log('Please connect to MetaMask.');
                } else {
                    console.error("err:"+error);
                }
            });
                console.log('==');
            }
            else{
                console.log('没有安装插件')
            }
        },
    },
    mounted(){
        this.shareLeaderCode = this.$route.query.share
        if(this.$store.state.globalAddress =="" || !this.$store.state.islogin){
            this.userlogin()
        }
    }
}
</script>
<style lang="less">
.layout-header {
    display: flex;
    justify-content: space-between;
    position: fixed;
    align-items: center;
    width: 375px;
    height: 61px;
    padding: 0 15px 0 5px;
    top: 0;
    z-index: 22;
    backdrop-filter: blur(50px);
    --webkit-filter: blur(50px);
border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    >div {
        display: flex;

        .logo {
            width: 150px;
           
        }

        .menu {
            width: 24px;
            height: 24px;
        }
    }

    &-r {
        display: flex;


        &-c {
            margin-left: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(180deg, #1A333E 0%, #0B171D 100%);
            box-shadow: 0px 0px 4px 0px rgba(0, 109, 121, 0.5);
            border-radius: 12px;
            border: 1px solid #176B77;
            font-family: DINPro, DINPro;
            font-weight: 500;
            font-size: 12px;
            color: #CFFCFF;
            line-height: 15px;
            padding: 8px 12px;

            .point {
                width: 6px;
                height: 6px;
                background: #DEFF9B;
                box-shadow: 0px 0px 4px 0px rgba(222, 255, 155, 0.5);
                border-radius: 50%;
                margin-right: 6px;
            }

        }

        .lang {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .menu {
            margin-left: 10px;
        }

        img {

            width: 32px;
            height: 32px;

        }



    }

}

.van-popover__arrow {
    // left: 65% !important;
    // border-bottom-color: #141414 !important;
    // box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
    display: none;
}

.van-popover__content {
    background: transparent !important;
}

.lang-popup {
    font-size: 12px;
    background: linear-gradient(224deg, rgba(12, 17, 20, 0) 0%, #343C2A 100%, #343C2A 100%), radial-gradient(43% 43% at 96% 0%, #17343B 0%, rgba(16, 21, 25, 0) 100%), #0C0F14;
    border-radius: 18px;
    padding: 10px;
    border: 1px solid;
    // border-image: linear-gradient(180deg, rgba(246, 255, 198, 0.1), rgba(255, 255, 255, 0), rgba(246, 255, 198, 0.1)) 1 1;

    .lang-title {
        font-size: 12px;
        color: #FFFFFF;
        line-height: 17px;
        opacity: 0.5;
        margin-bottom: 6px;
    }

    .lang-grid {
        display: grid;
        grid-template-columns: repeat(3, 52px);
        row-gap: 3px;
        column-gap: 4px;

        >div {
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 13px;
            color: #FFFFFF;
            line-height: 18px;
            border-radius: 15px;
            cursor: pointer;
            transition: all 0.2s;
            background: #151A1D;
            border: 1px solid #2C3134;

            &:hover {
                background: #133D46;
                border: 1px solid #188590;
                color: #9FF3FF;
            }

            &.active {
                background: #133D46;
                border: 1px solid #188590;
                color: #9FF3FF;
            }
        }
    }
}

.menuPopup {
    width: 275px;
    height: 100%;
background: linear-gradient( 180deg, rgba(10, 19, 26, 0.8) 0%, rgba(5, 8, 13, 0.8) 100%);
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    padding: 30px 15px;
    overflow-y: auto;

    .menu-header {
        margin-bottom: 16px;
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;

        >img {
            width: 36px;
            height: 36px;
            cursor: pointer;
        }

        .logo {

            img {
                width: 78px;
                height: 22px;
            }
        }
    }

    .user-info {
        height: 56px;
        background: #0C0F14;
        border-radius: 12px;
        border: 1px solid #24272B;
        padding: 9px 13px;
        display: flex;

        .tier-badge {
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: DINPro, DINPro;
            font-weight: 500;
            font-size: 13px;
            color: #DEFF9A;
            line-height: 16px;
            width: 36px;
            height: 36px;
            border-radius: 9px;
            background: linear-gradient(47deg, rgba(16, 241, 248, 1), rgba(222, 255, 154, 1));
            margin-right: 8px;

            >div {
                width: calc(100% - 2px);
                height: calc(100% - 2px);
                background: #0A0E18;
                border-radius: 9px;
                display: flex;
                align-items: center;
                justify-content: center;
            }

        }

        .user-tier {
            margin-top: 5px;

            >div {
                font-size: 13px;
                color: #FFFFFF;
                line-height: 18px;

                span {
                    margin-left: 4px;
                    font-family: DINPro, DINPro;
                    font-weight: 500;
                    font-size: 10px;
                    color: #DEFF9A;
                    line-height: 12px;
                    padding: 1px 5px;
                    border: 1px solid #5C6B48;
                    border-radius: 6px;
                    background: #1F2421;
                }
            }


            .tier-label {
                font-size: 10px;
                color: #FFFFFF;
                line-height: 14px;
                opacity: 0.5;
            }
        }
    }

    .menu-section {
        margin-top: 15px;

        .section-title {
            font-size: 12px;
            color: #FFFFFF;
            line-height: 17px;
            opacity: 0.5;
            margin-bottom: 6px;

        }

        .menu-item {
            border-radius: 12px;
            display: flex;
            align-items: center;
            padding: 12px 13px;
            cursor: pointer;
            transition: opacity 0.2s;
            &.active {
                position: relative;
                background: linear-gradient( 90deg, #0F2731 0%, rgba(8,15,21,0) 100%);
                .icon {
                    border: 1px solid #188590;
                    background: #133D46;
                }
                &::before{
                    content: '';
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    left: -15px;
                    border-radius: 0 12px 12px 0;
                    background: #00F0FF;
                    width: 4px;
                    height: 38px;
                }
            }
            &:hover {
                opacity: 0.7;
            }

            .icon {
                width: 32px;
                height: 32px;
                background: #151A1D;
                border-radius: 10px;
                border: 1px solid #2C3134;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 12px;

              

                >img {
                    width: 15px;
                    height: 15px;
                }
            }

            >span {
                font-weight: 500;
                font-size: 13px;
                color: #FFFFFF;
                line-height: 18px;
            }

            .badge {
                margin-left: auto;
                font-weight: 500;
                font-size: 12px;
                color: #9FF3FF;
                line-height: 17px;
                padding: 2px 8px;

                background: #0B1B22;
                box-shadow: 0px 0px 4px 0px rgba(0, 109, 121, 0.5);
                border-radius: 16px;
                border: 1px solid #176B77;
            }
        }
    }

    .menu-langs {
        background: #0C0F14;
        border-radius: 12px;
        border: 1px solid #24272B;
        margin-top: 6px;
        padding: 12px;

        .section-title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 8px;

            >div {
                font-size: 12px;
                color: #FFFFFF;
                line-height: 17px;
                opacity: 0.5;
            }

            >span {
                font-size: 12px;
                color: #9FF3FF;
                line-height: 17px;
            }

        }
    }

    .lang-grid {
        display: grid;
        flex-wrap: wrap;
        row-gap: 4px;
        column-gap: 3px;
        margin-bottom: 4px;
        grid-template-columns: repeat(6, 34px);

        >div {
            text-align: center;
            background: #151A1D;
            border-radius: 13px;
            border: 1px solid #2C3134;
            padding: 4px 8px;
            cursor: pointer;
            font-size: 12px;
            color: #FFFFFF;
            line-height: 17px;

            &.active {
                background: #133D46;
                border: 1px solid #188590;
                color: #9FF3FF;
            }

            &:hover {
                color: #9FF3FF;

            }
        }
    }
}
</style>